module.exports = __webpack_public_path__ + "img/system.2a216001.jpg";